
export default {
  props: {
    saving: {type: Boolean, default: false},
    atLimit: {type: Boolean, default: false},
    symbolLimit: {type: Number, required: true},
    memoryLimit: {type: Number, required: true},
  },
  emits: ['add', 'save'],
  data() {
    return {
      draft: '',
      prev_draft: '',
      editing_index: undefined,
    }
  },
  computed: {
    disabled() {
      return this.saving || (this.atLimit && this.editing_index === undefined)
    },
    placeholder() {
      if (this.atLimit && this.editing_index === undefined) return 'Cannot have more than ' + this.memoryLimit + ' memories'
      return this.editing_index === undefined ? 'User prefers shorter answers' : ''
    },
    trimmed_draft() {
      return this.draft.trim()
    },
    can_add() {
      return !!this.trimmed_draft && !this.atLimit && !this.saving
    },
    can_save() {
      return !!this.trimmed_draft && this.trimmed_draft !== this.prev_draft && !this.saving
    },
  },
  methods: {
    edit(index, text) {
      this.editing_index = index
      this.prev_draft = text
      this.draft = text
      this.$nextTick(() => this.$refs.textarea.focusEnd())
    },
    onAdd() {
      if (!this.can_add) return
      const text = this.trimmed_draft
      this.$emit('add', text)
    },
    onSave() {
      if (!this.can_save) return
      const index = this.editing_index
      const text = this.trimmed_draft
      this.$emit('save', index, text)
    },
    onDiscard() {
      this.draft = ''
      this.prev_draft = ''
      this.editing_index = undefined
    },
  }
}
